﻿function setFuelPriceDate(event) {
    event.preventDefault();
    $(event.target).parents('form').submit();
}

function drawChart(serverData) {
    var data = google.visualization.arrayToDataTable(serverData);

    var options = {
        title: 'Nationwide average fuel price per litre (pence)',
        curveType: 'function',
        legend: { position: 'bottom' },
        chartArea: { width: '80%' }
    };

    var chart = new google.visualization.LineChart(document.getElementById('curve_chart'));

    chart.draw(data, options);
}

function getServerData() {
    $.get('/regional-fuel-prices/average-price-chart-data', drawChart);
}

export function setupRegionalFuelPrices() {
    if (!$('[data-regional-fuel-prices]').length)
        return;

    // Define the callback function
    function init() {
        getServerData();
        $(document).on('change', '[data-regional-fuel-price-date]', setFuelPriceDate);

        $('#regional-fuel-prices-table').DataTable({
            responsive: true,
            "bPageinate": false,
            "bFilter": false,
            "bInfo": false,
            "bAutoWidth": false,
            "bLengthChange": false,
            "bSearchable": false,
            "iDisplayLength": -1,
            "order": [],
            "fnDrawCallback": function (oSettings) {
                $('.dataTables_paginate').hide();
            }
        });
    }

    // Load the API and specify the init function as callback
    google.charts.load('current', { 
        packages: ['corechart'],
        callback: init  // This ensures init is called only after Google Charts is fully loaded
    });
}